import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { ModalComponent } from '../../layout/modals/ModalComponent';
import { FormField, FormFieldTypes } from '../../layout/form-fields/FormField';
import { locationStore } from './LocationStore';

const defaultValues = {
	name: ''
};

const ValidationSchema = Yup.object().shape({
	name: Yup.string().required().label('Name')
});

export class LocationForm extends ModalComponent {
	get isEdit() {
		return this.props.data !== undefined;
	}

	render() {
		return (
			<Formik
				initialValues={{
					...defaultValues,
					...this.props.data
				}}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.save(values);
				}}>
				{formikBag => this.renderModalContainer(formikBag, 'LocationForm')}
			</Formik>
		);
	}

	renderForm(formikBag) {
		return (
			<div className="columns">
				<div className="column is-full">
					<FormField
						key="name"
						required
						className="has-text-left"
						label="Name"
						field="name"
						type={FormFieldTypes.TEXT}
						placeholder="Name"
					/>
				</div>
			</div>
		);
	}

	async save(values) {
		if (this.isEdit) {
			return locationStore
				.update(this.props.data.id, {
					location: values
				})
				.then(result => {
					this.resultNotification(result, 'Location', 'Update');

					return result;
				});
		} else {
			return locationStore.create(values).then(result => {
				this.resultNotification(result, 'Location', 'Create');

				return result;
			});
		}
	}
}
